// extracted by mini-css-extract-plugin
export default {"intro":"IntroSection_intro__5V2Bs","intro__btn":"IntroSection_intro__btn__DSCa2","intro__arrowRight":"IntroSection_intro__arrowRight__G9c+8"};